<template>
  <div class="panel">
    <div class="title">
      <span>{{ platformInfo.locationGroupName }}</span>
      <span @click="deleteInfo" v-if="!isPreview" class="delete"
        ><i class="iconfont icon-icon_trash" />删除</span
      >
    </div>
    <div class="select_location">
      <span class="select_location__label">选择位置</span>
      <div v-if="isPreview" style="display: flex">
        <p
          v-for="(name, nameIndex) in locationName"
          :key="nameIndex"
          class="choosePosition"
        >
          <span style="width: 16px; height: 16px; background: #dde4f0"
            ><i class="el-icon-check" style="color: #91959f"></i
          ></span>
          {{ name }}
        </p>
      </div>
      <el-checkbox-group
        v-else
        @change="changeLocation"
        v-model="platformData.location"
      >
        <el-checkbox
          :label="item.locationUid"
          :key="item.locationUid"
          @click="changeLocationCell"
          v-for="item in platformInfo.locationDtoList"
        >
          {{ item.locationName }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div v-for="(item, index) in selectedLocation" :key="item.locationUid">
      <div class="set_image">
        <div class="headline">
          <div class="number">
            {{ item.index + 1 }}
          </div>
          <div class="location_name">{{ item.locationName }}</div>
          <el-button
            type="text"
            @click="showPreview(item)"
            class="preview"
            :class="{
              'preview-disabled':
                !(
                  platformData.imageList.find(
                    (img) => img.index === item.index
                  ) &&
                  platformData.imageList.find((img) => img.index === item.index)
                    .url
                ) &&
                item.locationUid != 1006 &&
                item.locationUid != 1005 &&
                item.locationUid != 1007 &&
                item.locationUid != 3007 &&
                item.locationUid != 10003,
            }"
          >
            预览
          </el-button>
          <span></span>
          <a @click="changeLocationCellItem(item.locationUid)">删除</a>
          <div
            v-if="
              item.popRateShow &&
              ((item.locationUid == 1008 && item.centerHtmlType !== 1) ||
                item.locationUid != 1008)
            "
            class="set_dialog"
          >
            <span class="set_dialog__label">弹窗频率</span>
            <el-select
              :disabled="isPreview"
              v-model="platformData.dialogFrequency[item.index]"
              clearable
              placeholder="请选择弹窗频率"
            >
              <el-option
                v-for="item in item.popRateList"
                :key="item.code"
                :label="item.msg"
                :value="item.code"
                >{{ item.msg }}</el-option
              >
            </el-select>
          </div>
        </div>
        <section v-if="item.locationUid == 3007 && !isPreview">
          <div
            class="item3007"
            v-for="(f, fIndex) in item.mobileOfficialWebsiteVoList"
            :key="fIndex"
          >
            <div class="item3007-headlineSec">
              <span>精选产品TAB{{ fIndex + 1 }}</span>
              <span @click="deleteTab(index, fIndex)">删除</span>
            </div>
            <div class="link" v-if="!isPreview">
              <span class="label">TAB名称{{ fIndex + 1 }}</span>
              <el-input
                :disabled="isPreview"
                class="link_url"
                maxlength="6"
                v-model="f.tabName"
                show-word-limit
                placeholder="请输入链接地址"
              ></el-input>
            </div>
            <div class="link" v-if="!isPreview">
              <span class="label">跳转链接</span>
              <el-input
                :disabled="isPreview"
                v-model="f.imgSkipUrl"
                class="link_url"
                placeholder="请输入链接地址"
              ></el-input>
            </div>
            <div class="item3007-uploader">
              <span>图片</span>
              <div
                style="display: flex; flex-direction: column"
                class="item3007-uploaderDiv"
              >
                <el-upload
                  :on-preview="handlePictureCardPreview"
                  name="img"
                  :http-request="
                    function (...par) {
                      return uploadFn(...par, item.index, 1);
                    }
                  "
                  list-type="picture-card"
                  :on-success="
                    function (response, file, fileList) {
                      return handleUploadSuccess3007(response, fIndex);
                    }
                  "
                  :on-error="
                    function (response, file, fileList) {
                      return handleUploadError(
                        response,
                        file,
                        fileList,
                        item.index
                      );
                    }
                  "
                  :on-remove="
                    function (file, fileList) {
                      return removeUpload(file, fileList, item.index);
                    }
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <span
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #9ca0a8;
                    margin-top: 5px;
                  "
                  >{{ item.width }}x{{ item.height }}px <br />
                  最大为5M</span
                >
              </div>
            </div>
          </div>
          <div class="item3007-add">
            <span @click="addTab(index)">+ 新建TAB位</span>
            <span>最大支持配置4个TAB，展示将按配置顺序</span>
          </div>
        </section>
        <section v-else-if="item.locationUid == 3007 && isPreview">
          <div
            class="item3007"
            v-for="(f, fIndex) in item.mobileOfficialWebsiteDtoList"
            :key="fIndex"
          >
            <div class="item3007-headlineSec">
              <span>精选产品TAB{{ fIndex + 1 }}</span>
            </div>
            <div class="link">
              <span class="label">TAB名称{{ fIndex + 1 }}</span>
              <span>{{ f.tabName }}</span>
            </div>
            <div class="link">
              <span class="label">跳转链接</span>
              <span>{{ f.imgSkipUrl }}</span>
            </div>
            <div class="item3007-uploader">
              <span>图片</span>
              <img :src="'//' + f.imgUrl" alt="" />
            </div>
          </div>
        </section>
        <section v-else-if="item.locationUid == 10003 && !isPreview">
          <div class="link link-1006_bottom">
            <span class="label">网址链接</span>
            <el-input
              placeholder="请输入内容"
              v-model="item.aiSettingVideoLink"
            >
            </el-input>
          </div>
        </section>
        <section v-else-if="item.locationUid == 10003 && isPreview">
          <div class="link link-1006_bottom">
            <span class="label">网址链接</span>
            <span>{{ item.aiSettingVideoLink }}</span>
          </div>
        </section>
        <section v-else-if="item.locationUid == 1006 && !isPreview">
          <div class="link link-1006_bottom">
            <span class="label">标题</span>
            <el-input
              placeholder="请输入内容"
              v-model="item.bottomRightWindowTitle"
            >
            </el-input>
          </div>
          <div class="link link-1006">
            <span class="label">内容</span>
            <div>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                v-model="item.bottomRightWindowContent"
              >
              </el-input>
            </div>
          </div>
          <div class="link link-1006_bottom">
            <span class="label">按钮</span>
            <el-input
              placeholder="请输入内容"
              v-model="item.bottomRightWindowButton"
              maxlength="12"
            >
            </el-input>
          </div>
          <div class="link link-1006_bottom">
            <span class="label">跳转链接</span>
            <el-input
              placeholder="请输入内容"
              v-model="item.bottomRightWindowSkipUrl"
            >
            </el-input>
          </div>
        </section>
        <section v-else-if="item.locationUid == 1006 && isPreview">
          <div class="link link-1006_bottom">
            <span class="label">标题</span>
            <span>{{ item.bottomRightWindowTitle }}</span>
          </div>
          <div class="link link-1006">
            <span class="label">内容</span>
            <span>{{ item.bottomRightWindowContent }}</span>
          </div>
          <div class="link link-1006_bottom">
            <span class="label">按钮</span>
            <span>{{ item.bottomRightWindowButton }}</span>
          </div>
          <div class="link link-1006_bottom">
            <span class="label">跳转链接</span>
            <span>{{ item.bottomRightWindowSkipUrl }}</span>
          </div>
        </section>
        <section v-else-if="item.locationUid == 1007 && !isPreview">
          <div class="link link-1005">
            <span class="label">文案</span>
            <div>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                maxlength="60"
                v-model="item.generalViewContent"
              >
              </el-input>
              <div class="link-1005Button_wrap">
                <div
                  class="link-1005Button"
                  @click="toPushText(index, item.generalViewContent || '', 2)"
                >
                  * 高亮文案
                </div>
                <div
                  class="link-1005Button"
                  @click="toPushText(index, item.generalViewContent || '', 1)"
                >
                  # 按钮文案
                </div>
              </div>
            </div>
          </div>
          <div class="link link-1005_bottom">
            <span class="label">按钮触发</span>
            <el-radio-group v-model="item.generalViewBottomRadio">
              <el-radio :label="0">弹出联系方式</el-radio>
              <el-radio :label="1">链接跳转</el-radio>
            </el-radio-group>
            <el-popover
              placement="right"
              width="180"
              trigger="hover"
              popper-class="popper"
            >
              <template #reference>
                <span class="link-1007_span">示意图</span>
              </template>
              <div class="link-1007_span_wrap">
                <span>支付专员联系方式:</span>
                <span>15659290667</span>
                <img
                  v-if="item.generalViewQrCodeUrl"
                  :src="item.generalViewQrCodeUrl"
                  alt=""
                />
                <span>扫一扫添加支付专员</span>
              </div>
            </el-popover>
          </div>
          <div v-if="item.generalViewBottomRadio == 0">
            <div>
              <div class="link link-1005_bottom">
                <span class="label">联系电话</span>
                <el-input
                  placeholder="请输入内容"
                  v-model="item.generalViewTel"
                >
                </el-input>
              </div>
            </div>
            <div>
              <div class="link link-1005_bottom">
                <span class="label">二维码</span>
                <div
                  style="display: flex; flex-direction: column"
                  class="item3007-uploaderDiv"
                >
                  <el-upload
                    class="avatar-uploader image-uploader"
                    :on-exceed="imgExceed"
                    :on-preview="handlePictureCardPreview"
                    name="img"
                    :http-request="
                      function (...par) {
                        return uploadFn(...par, item.index, 1);
                      }
                    "
                    list-type="picture-card"
                    :on-success="
                      function (response, file, fileList) {
                        return handleUploadSuccess2(
                          response,
                          file,
                          fileList,
                          true
                        );
                      }
                    "
                    :on-error="
                      function (response, file, fileList) {
                        return handleUploadError(
                          response,
                          file,
                          fileList,
                          item.index
                        );
                      }
                    "
                    :on-remove="
                      function (file, fileList) {
                        return removeUpload(file, fileList, item.index);
                      }
                    "
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <span style="text-align: center"
                    >600x600px <br />
                    最大为10M</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="link link-1005_bottom" v-else>
            <span class="label">链接地址</span>
            <el-input
              placeholder="请输入内容"
              v-model="item.generalViewSkipUrl"
            >
            </el-input>
          </div>
        </section>
        <section v-else-if="item.locationUid == 1007 && isPreview">
          <div class="link link-1006_bottom">
            <span class="label">标题</span>
            <span>{{ item.generalViewContent }}</span>
          </div>
          <div class="link link-1006_bottom">
            <span class="label">按钮触发</span>
            <span>{{
              item.generalViewBottomRadio === 0 ? "弹出联系方式" : "链接跳转"
            }}</span>
          </div>

          <div v-if="item.generalViewBottomRadio == 0">
            <div>
              <div class="link link-1005_bottom">
                <span class="label">联系电话</span>
                <span>{{ item.generalViewTel }}</span>
              </div>
            </div>
            <div>
              <div class="link link-1005_bottom">
                <span class="label">二维码</span>
                <img :src="'//' + item.generalViewQrCodeUrl" alt="" />
              </div>
            </div>
          </div>
          <div class="link link-1005_bottom" v-else>
            <span class="label">链接地址</span>
            <span>{{ item.generalViewSkipUrl }}</span>
          </div>
        </section>
        <section v-else-if="item.locationUid == 1005 && !isPreview">
          <div class="link link-1005">
            <span class="label">文案</span>
            <div>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                maxlength="60"
                v-model="item.topTrabeculaContent"
              >
              </el-input>
              <div
                class="link-1005Button"
                @click="toPushText(index, item.topTrabeculaContent)"
              >
                # 按钮文案
              </div>
            </div>
          </div>
          <div class="link link-1005_bottom">
            <span class="label">跳转链接</span>
            <el-input
              placeholder="请输入内容"
              v-model="item.topTrabeculaSkipUrl"
            >
            </el-input>
          </div>
        </section>
        <section v-else-if="item.locationUid == 1005 && isPreview">
          <div class="link link-1005">
            <span class="label">文案</span>
            <span>{{ item.topTrabeculaContent }}</span>
          </div>
          <div class="link link-1005_bottom">
            <span class="label">跳转链接</span>
            <span>{{ item.topTrabeculaSkipUrl }}</span>
          </div>
        </section>
        <section v-else-if="item.locationUid == 1008">
          <div v-if="!isPreview" class="link">
            <span class="label">弹窗类型</span>
            <el-radio-group v-model="item.centerHtmlType">
              <el-radio :label="0">图片</el-radio>
              <el-radio :label="1">企业微信客服</el-radio>
            </el-radio-group>
            <el-popover
              :width="639"
              trigger="hover"
              v-if="item.centerHtmlType === 1"
            >
              <template #reference>
                <span class="look-location">示例</span>
              </template>
              <img src="@/assets/1008.png" alt="" />
            </el-popover>
          </div>
          <div v-if="isPreview" class="link">
            <li style="color: #dde4f0; margin-left: -22px">
              <span class="label"
                >弹窗类型
                {{ item.centerHtmlType === 0 ? "图片" : "企业微信客服" }}</span
              >
            </li>
          </div>
          <div class="upload_image" v-if="item.centerHtmlType === 0">
            <el-upload
              list-type="picture-card"
              class="image-uploader"
              name="img"
              :disabled="isPreview"
              :file-list="allImgList[item.index]"
              :id="item.locationUid"
              :ref="item.locationUid"
              :key="item.locationUid"
              :limit="1"
              :on-exceed="imgExceed"
              :on-preview="handlePictureCardPreview"
              :http-request="
                function (...par) {
                  return uploadFn(...par, item.index);
                }
              "
              :on-success="
                function (response, file, fileList) {
                  return handleUploadSuccess(
                    response,
                    file,
                    fileList,
                    item.index
                  );
                }
              "
              :on-error="
                function (response, file, fileList) {
                  return handleUploadError(
                    response,
                    file,
                    fileList,
                    item.index
                  );
                }
              "
              :on-remove="
                function (file, fileList) {
                  return removeUpload(file, fileList, item.index);
                }
              "
            >
              <i class="el-icon-plus"></i>
              <template #tip>
                <div class="el-upload__tip">{{ item.remark }}</div>
              </template>
            </el-upload>
          </div>
          <div class="link" v-if="item.centerHtmlType === 0">
            <span class="label">跳转链接</span>
            <el-input
              :disabled="isPreview"
              v-model="item.imgSkipUrl"
              class="link_url"
              placeholder="请输入链接地址"
            ></el-input>
          </div>
        </section>
        <section v-else>
          <div class="upload_image">
            <el-upload
              list-type="picture-card"
              class="image-uploader"
              name="img"
              :disabled="isPreview"
              :file-list="allImgList[item.index]"
              :id="item.locationUid"
              :ref="item.locationUid"
              :key="item.locationUid"
              :limit="1"
              :on-exceed="imgExceed"
              :on-preview="handlePictureCardPreview"
              :http-request="
                function (...par) {
                  return uploadFn(...par, item.index);
                }
              "
              :on-success="
                function (response, file, fileList) {
                  return handleUploadSuccess(
                    response,
                    file,
                    fileList,
                    item.index
                  );
                }
              "
              :on-error="
                function (response, file, fileList) {
                  return handleUploadError(
                    response,
                    file,
                    fileList,
                    item.index
                  );
                }
              "
              :on-remove="
                function (file, fileList) {
                  return removeUpload(file, fileList, item.index);
                }
              "
            >
              <i class="el-icon-plus"></i>
              <template #tip>
                <div class="el-upload__tip">{{ item.remark }}</div>
              </template>
            </el-upload>
            <el-dialog
              center
              v-if="isLoginOrRegister == 'other'"
              title="预览"
              destroy-on-close
              :width="800"
              v-model="showDialog"
              :before-close="handleCloseDialog"
            >
              <div class="preview_panel" :style="previewBackground">
                <el-image
                  draggable="false"
                  :style="previewImgStyle"
                  :src="getPreviewImg"
                />
              </div>
            </el-dialog>
            <el-dialog
              center
              v-if="isLoginOrRegister == 'login' && showUid == item.locationUid"
              title="预览"
              destroy-on-close
              :width="2200"
              v-model="showDialog"
              :before-close="handleCloseDialog"
            >
              <iframe
                :id="'iframeLogin' + item.locationUid"
                frameborder="0"
                scrolling="no"
                class="iframe"
              ></iframe>
            </el-dialog>
            <el-dialog
              center
              v-if="
                isLoginOrRegister == 'register' && showUid == item.locationUid
              "
              title="预览"
              destroy-on-close
              :width="2200"
              v-model="showDialog"
              :before-close="handleCloseDialog"
            >
              <iframe
                :id="'iframeRegister' + item.locationUid"
                frameborder="0"
                scrolling="no"
                class="iframe"
              ></iframe>
            </el-dialog>
          </div>
          <div class="link" v-if="!isPreview">
            <span class="label">跳转链接</span>
            <el-switch
              :disabled="isPreview"
              class="switch"
              style="display: block"
              :value="
                platformData.linkList[item.index] &&
                platformData.linkList[item.index].switch
              "
              @change="
                (data) => {
                  changeLinkSwitch(data, item.index);
                }
              "
            >
            </el-switch>
            <el-input
              :disabled="isPreview"
              v-model="platformData.linkList[item.index].url"
              v-if="
                platformData.linkList[item.index] &&
                platformData.linkList[item.index].switch
              "
              @change="
                (data) => {
                  checkDomainFn(data, item);
                }
              "
              class="link_url"
              placeholder="请输入链接地址"
            ></el-input>
          </div>
          <div
            class="link"
            v-if="isPreview && platformData.linkList[item.index]"
          >
            <li style="color: #dde4f0; margin-left: -22px">
              <span class="label"
                >链接
                <el-link
                  type="primary"
                  :href="platformData.linkList[item.index].url"
                  target="_blank"
                  >{{ platformData.linkList[item.index].url }}</el-link
                ></span
              >
            </li>
          </div>
          <div v-if="item.weightShow && !isPreview" class="link">
            <span class="label">展示权重</span>
            <el-input-number
              :disabled="isPreview"
              v-model="platformData.weightList[item.index]"
              class="link_url"
              :min="0"
              placeholder="请输入权重数值"
            ></el-input-number>
          </div>
          <div v-if="item.weightShow && isPreview" class="link">
            <li style="color: #dde4f0; margin-left: -22px">
              <span class="label">权重 {{ item.computedWeight }}%</span>
            </li>
          </div>
          <div v-if="item.bgFillingShow && !isPreview" class="link">
            <span class="label">填充背景</span>
            <div class="linkInner">
              <el-radio v-model="item.bgFilling" :label="0">纯色</el-radio>
              <el-input
                v-if="item.bgFilling === 0"
                placeholder="#000000"
                v-model="item.rgb"
              >
                <template v-slot:prefix>
                  <i
                    class="showColorDemo"
                    :style="{
                      background: item.bgFilling === 0 ? item.rgb : '',
                    }"
                  ></i>
                </template>
              </el-input>
            </div>
            <div class="linkInner">
              <el-radio v-model="item.bgFilling" :label="1">渐变</el-radio>
              <el-input
                v-if="item.bgFilling === 1"
                placeholder="#000000"
                v-model="item.rgb"
              >
                <template v-slot:prefix>
                  <i
                    class="showColorDemo"
                    :style="{
                      background: item.bgFilling === 1 ? item.rgb : '',
                    }"
                  ></i>
                </template>
              </el-input>
              <span v-if="item.bgFilling === 1">—</span>
              <el-input
                v-if="item.bgFilling === 1"
                placeholder="#000000"
                v-model="item.rgb2"
              >
                <template v-slot:prefix>
                  <i
                    class="showColorDemo"
                    :style="{ background: item.rgb2 }"
                  ></i>
                </template>
              </el-input>
            </div>
          </div>
          <div v-if="item.bgFillingShow && isPreview" class="link">
            <span class="label">填充背景</span>
            <div class="linkInner" v-if="item.bgFilling === 0">
              <span>纯色</span>
              <div class="linkInnerShow">
                <span :style="{ background: item.rgb }"></span>
                <span>{{ item.rgb }}</span>
              </div>
            </div>
            <div class="linkInner" v-if="item.bgFilling === 1">
              <span>渐变</span>
              <div class="linkInnerShow">
                <span :style="{ background: item.rgb }"></span>
                <span>{{ item.rgb }}</span>
                <span>—</span>
                <span :style="{ background: item.rgb2 }"></span>
                <span>{{ item.rgb2 }}</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <el-dialog
      center
      destroy-on-close
      :width="1310"
      custom-class="location1007-dialog"
      v-model="show1007Dialog"
    >
      <div>
        <section class="location1007-dialogItem">
          <span>概览版本一:</span>
          <div>
            <img src="@/assets/location10071.png" alt="" />
            <div v-html="active1007Map.content"></div>
          </div>
        </section>
        <section class="location1007-dialogItem location1007-dialogItem2">
          <span>概览版本二:</span>
          <div>
            <img src="@/assets/location10072.png" alt="" />
            <div v-html="active1007Map.content"></div>
          </div>
        </section>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="预览"
      destroy-on-close
      :width="1010"
      custom-class="location1005-dialog"
      v-model="show1005Dialog"
    >
      <div class="dashboard-notice__item" data='{"Type":107}'>
        <span class="icon_error"></span
        ><text v-html="active1005Map.topTrabeculaContent"> </text>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="预览"
      destroy-on-close
      :width="400"
      custom-class="location1005-dialog"
      v-model="show1006Dialog"
    >
      <div class="spread_douyin">
        <div class="title">
          <div class="icon"></div>
          <div class="hot"></div>
          <div class="split"></div>
          <div class="tl">{{ active1006Map.bottomRightWindowTitle }}</div>
          <div class="popupClose"></div>
        </div>
        <div class="content">
          <span>{{ active1006Map.bottomRightWindowContent }}</span>
          <div class="opeartion">
            {{ active1006Map.bottomRightWindowButton }}
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      destroy-on-close
      :width="343"
      :show-close="false"
      custom-class="location3007-dialog"
      v-model="show3007Dialog"
    >
      <div class="location3007-content">
        <div class="location3007-contentHeader">
          <span>精选产品</span>
          <span>为门店实现高效数字化经营</span>
        </div>
        <div class="location3007-tabs">
          <span
            class=""
            :class="{
              'location3007-tabsactive': location3007TabIndex === index,
            }"
            @click="location3007TabIndex = index"
            v-for="(item, index) in value3007Dialog"
            :key="index"
            >{{ item.tabName }}</span
          >
        </div>
        <div class="location3007-swiperWrap">
          <div
            class="location3007-swiper"
            :style="{
              transform: 'translateX(-' + 300 * location3007TabIndex + 'px)',
            }"
          >
            <div v-for="(item, index) in value3007Dialog" :key="index">
              <img :src="'//' + item.imgUrl" alt="" />
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      destroy-on-close
      :width="1000"
      :show-close="false"
      custom-class="location10003-dialog"
      v-model="show10003Dialog"
    >
      <img src="@/assets/rengong.png" alt="" />
    </el-dialog>
    <el-dialog v-model="dialogVisible" custom-class="location3007-dialogImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import config from '../../../config'
import previewConfig from '../../../utils/previewConfig'
import { checkDomain, getPreviewHtml, uploadImg, uploadNoDeleteImg, deleteTargetLocationMappingByTemplateUidAndLocationGroupUid, deleteTargetLocationMapping } from '../../../API/template'
export default {
  props: {
    platformInfo: {
      type: Object,
      default: () => {
        return {
        }
      }
    },
    templateUid: {
      type: String,
      default: ''
    },
    platformList: {
      type: Array,
      default: () => []
    },
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  created () {
    console.log('this.platformInfo', this.platformInfo)
    _.forEach(this.platformInfo.locationDtoList, (item, index) => {
      if (item.imgUrl || item.choosed) {
        this.platformData.location.push(item.locationUid)
        this.locationName.push(item.locationName)
        this.platformData.imageList.push({ index, url: `//${item.imgUrl}`, locationUid: item.locationUid })
        this.platformData.weightList[index] = item.weight
        if (item.imgSkipUrl) {
          this.platformData.linkList[index] = {
            index, switch: true, url: item.imgSkipUrl
          }
        }
        if (item.popRate !== null) {
          this.platformData.dialogFrequency[index] = item.popRate + ''
        }
      }
    })
    console.log('this.platformData', this.platformData)
  },
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      imageUrl: '',
      location3007TabIndex: 0,
      show3007Dialog: false,
      show1007Dialog: false,
      show10003Dialog: false,
      value3007Dialog: [],
      show1005Dialog: false,
      show1006Dialog: false,
      active1007Map: {},
      active1005Map: {},
      active1006Map: {},
      allImgList: [[], [], [], [], [], [], [], [], []],
      betweenColorLast: '',
      betweenColorFirst: '',
      radioColor: '1',
      showDialog: false,
      showUid: -1,
      previewIndex: '',
      locationName: [],
      allColor: '',
      platformData: {
        location: [],
        imageList: [

        ],
        weightList: [],
        linkList: [],
        dialogFrequency: [],
        previewConfig: {}
      },
      needDeleteTargetLocations: []
    }
  },
  watch: {
    'platformData.imageList': {
      handler: function () {
        this.selectedLocation.forEach((item, index) => {
          const locationDtoList = this.platformInfo.locationDtoList
          const imageList = this.platformData.imageList
          const i = locationDtoList.findIndex(locationDto => locationDto.locationUid === item.locationUid)
          const imgInfo = imageList.find(item => {
            return item.index + '' === i + ''
          })
          var imgList = []
          if (imgInfo) {
            imgList = [imgInfo]
          }
          this.allImgList.splice(item.index, 1, imgList)
        })
      },
      deep: true

    }
  },
  methods: {
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    deleteTab (index, fIndex) {
      const item = this.selectedLocation[index]
      item.mobileOfficialWebsiteVoList.splice(fIndex, 1)
    },
    addTab (index) {
      const item = this.selectedLocation[index]
      if (item.mobileOfficialWebsiteVoList.length < 4) {
        item.mobileOfficialWebsiteVoList.push({
          tabName: '',
          imgUrl: '',
          imgSkipUrl: ''
        })
      } else {
        this.$message.error('此广告位最多支持配置4个tab')
      }
    },
    toPushText (index, value, type) {
      if (type !== 2) {
        const matchArr = value.match(/#(\S*)#/)
        if (!matchArr) {
          if (type === 1) {
            this.selectedLocation[index].generalViewContent = (value || '') + '#按钮文案#'
          } else {
            this.selectedLocation[index].topTrabeculaContent = (value || '') + '#按钮文案#'
          }
        } else {
          this.$message.error('此广告位仅支持配置一个按钮')
        }
      } else {
        const matchArr = value.match(/\*(\S*)\*/)
        if (!matchArr) {
          this.selectedLocation[index].generalViewContent = (value || '') + '*高亮文案*'
        } else {
          this.$message.error('此广告位仅支持配置一个高亮文案')
        }
      }
    },
    async changeLocationCellItem (value) {
      const oldLocation = this.platformData.location
      const i = this.platformData.location.findIndex(item => item === value)
      if (i !== -1) {
        const _location = this.platformInfo.locationDtoList.find(item => item.locationUid === this.platformData.location[i])
        const imgIndex = this.platformData.imageList[i] ? 1 : -1
        if (imgIndex !== -1 && this.platformData.imageList.length <= 1 && this.platformList.length <= 1) {
          this.$confirm('删除后此方案会被清空', '确认删除最后一个含有图片的广告位？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const data = this.platformData.imageList
            _.remove(data, item => item.index === _location.index)
            this.platformData.imageList = data
            if (_location && _location.targetLocationMappingUid) {
              await deleteTargetLocationMapping(_location.targetLocationMappingUid)
            }
            _.pull(this.platformData.location, value)
            _.pullAllBy(this.platformData.imageList, item => item.index === i)
            this.$emit('deleteProjectByLast')
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }).catch(() => {
            this.platformData.location = oldLocation
          })
        } else {
          const data = this.platformData.imageList
          _.remove(data, item => item.index === _location.index)
          this.platformData.imageList = data
          this.needDeleteTargetLocations.push({
            locationUid: _location.locationUid,
            targetLocationMappingUid: _location.targetLocationMappingUid
          })
          _.pull(this.platformData.location, value)
          _.pullAllBy(this.platformData.imageList, item => item.index === i)
        }
      } else {
        this.needDeleteTargetLocations = this.needDeleteTargetLocations.filter(item => {
          return item.locationUid !== value
        })
        this.platformData.location.push(value)
        this.platformData.location = _.compact(this.platformData.location)
        console.log('this.platformData.location', this.platformData.location)
      }
      this.$emit('getNeedDeleteTargetLocations', this.needDeleteTargetLocations)
    },
    async changeLocationCell (value) {
      console.log('changeLocationCell', value.target.value)
      console.log('this.platformData', this.platformData)
      console.log('this.platformInfo', this.platformInfo)
      const oldLocation = this.platformData.location
      const i = this.platformData.location.findIndex(item => item === value.target.value)
      if (i !== -1) {
        const _location = this.platformInfo.locationDtoList.find(item => item.locationUid === this.platformData.location[i])
        const imgIndex = this.platformData.imageList[i] ? 1 : -1
        if (imgIndex !== -1 && this.platformData.imageList.length <= 1 && this.platformList.length <= 1) {
          this.$confirm('删除后此方案会被清空', '确认删除最后一个含有图片的广告位？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const data = this.platformData.imageList
            _.remove(data, item => item.index === _location.index)
            this.platformData.imageList = data
            if (_location && _location.targetLocationMappingUid) {
              await deleteTargetLocationMapping(_location.targetLocationMappingUid)
            }
            _.pull(this.platformData.location, value.target.value)
            _.pullAllBy(this.platformData.imageList, item => item.index === i)
            this.$emit('deleteProjectByLast')
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }).catch(() => {
            this.platformData.location = oldLocation
          })
        } else {
          const data = this.platformData.imageList
          _.remove(data, item => item.index === _location.index)
          this.platformData.imageList = data
          this.needDeleteTargetLocations.push({
            locationUid: _location.locationUid,
            targetLocationMappingUid: _location.targetLocationMappingUid
          })
          _.pull(this.platformData.location, value.target.value)
          _.pullAllBy(this.platformData.imageList, item => item.index === i)
        }
      } else {
        this.needDeleteTargetLocations = this.needDeleteTargetLocations.filter(item => {
          return item.locationUid !== value.target.value
        })
        this.platformData.location.push(value.target.value)
        this.platformData.location = _.compact(this.platformData.location)
        console.log('this.platformData.location', this.platformData.location)
      }
      this.$emit('getNeedDeleteTargetLocations', this.needDeleteTargetLocations)
    },
    changeLocation (value) {
      console.log('value', value)
      console.log('location', JSON.parse(JSON.stringify(this.platformData.location)))
    },
    async uploadFn (params, index, type) {
      const formData = new FormData()
      formData.append(params.filename, params.file)
      console.log('params', params)
      let res = ''

      if (type === 1) {
        res = await uploadNoDeleteImg(formData)
      } else {
        res = await uploadImg(formData)
      }

      if (res) {
        params.onSuccess(res)
      } else {
        params.onError(res)
      }
    },
    async checkDomainFn (data, info) {
      console.log('data', data)
      console.log('info', info)
      if (info.imgSkipUrlChecked) {
        const res = await checkDomain({ domain: data, locationUid: info.locationUid })
        console.log('res', res)
        if (res === '校验成功') {
          this.$notify.success('合法的跳转链接')
        } else {
          this.$notify.error(res)
        }
      }
    },
    // deletePlatform () {
    //   this.$confirm('删除后图片会被清空', '确认删除此平台投放？', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$message({
    //       type: 'success',
    //       message: '删除成功!'
    //     })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     })
    //   })
    // },
    imgExceed () {
      this.$notify.error({
        title: '错误',
        message: '广告位最多允许上传1张图片'
      })
    },
    handleCloseDialog () {
      this.showDialog = false
      this.showUid = -1
      this.previewIndex = ''
    },
    async showPreview (active) {
      this.previewIndex = active.index
      if (active.locationUid === '1006') {
        this.show1006Dialog = true
        this.active1006Map = {
          bottomRightWindowTitle: active.bottomRightWindowTitle,
          bottomRightWindowContent: active.bottomRightWindowContent,
          bottomRightWindowButton: active.bottomRightWindowButton
        }
      } else if (active.locationUid === '3007') {
        this.show3007Dialog = true
        this.value3007Dialog = active.mobileOfficialWebsiteDtoList || active.mobileOfficialWebsiteVoList
      } else if (active.locationUid === '10003') {
        this.show10003Dialog = true
      } else if (active.locationUid === '1007') {
        let content = active.generalViewContent || ''
        console.log(content)
        const matchArr = content.match(/#(\S*)#/)
        const matchArr2 = content.match(/\*(\S*)\*/)
        if (matchArr) {
          content = active.generalViewContent ? active.generalViewContent.replace(matchArr[0], `<font class="location1007-dialogItem_1">${matchArr[1]}</font>`) : ''
        }
        if (matchArr2) {
          content = content ? content.replace(matchArr2[0], `<font class="location1007-dialogItem_2">${matchArr2[1]}</font>`) : ''
        }
        console.log(content, matchArr, matchArr2)
        this.active1007Map = {
          content
        }
        console.log(this.show1007Dialog)
        this.show1007Dialog = true
      } else if (active.locationUid === '1005') {
        const matchArr = active.topTrabeculaContent.match(/#(\S*)#/)
        if (matchArr) {
          this.active1005Map = {
            topTrabeculaContent: active.topTrabeculaContent ? active.topTrabeculaContent.replace(matchArr[0], `<font class="btnToSetting btnShowEditPwd">${matchArr[1]}</font>`) : ''
          }
        } else {
          this.active1005Map = {
            topTrabeculaContent: active.topTrabeculaContent
          }
        }

        this.show1005Dialog = true
      } else if (this.isLoginOrRegister !== 'other') {
        const selectedLocation = this.selectedLocation.find(item => item.index === active.index)
        const data = {
          bgFilling: selectedLocation.bgFilling,
          imgSkipUrl: selectedLocation.imgSkipUrl,
          imgUrl: this.platformData.imageList.find(item => item.index === active.index).url.slice(2),
          locationUid: selectedLocation.locationUid,
          rgb: selectedLocation.rgb,
          rgb2: selectedLocation.rgb2
        }
        if (data.bgFilling !== '' && data.imgUrl && data.locationUid && ((data.bgFilling === 0 && data.rgb) || (data.bgFilling === 1 && data.rgb && data.rgb2))) {
          this.showDialog = true
          this.showUid = selectedLocation.locationUid
          const res = await getPreviewHtml(data)
          const id = this.isLoginOrRegister === 'login' ? 'iframeLogin' : 'iframeRegister'
          this.$nextTick(() => {
            var iframe = document.querySelector(`#${id}${selectedLocation.locationUid}`)
            iframe.srcdoc = `${res}`
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: '登录页和注册页广告位需选择填充背景方可预览'
          })
        }
      } else {
        this.showDialog = true
      }
    },
    async deleteInfo () {
      const self = this
      console.log('this', this)
      if (self.platformList.length <= 1) {
        this.$confirm('删除后此方案会被清空', '确认删除最后一个广告位？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          if (this.templateUid) {
            await deleteTargetLocationMappingByTemplateUidAndLocationGroupUid({ locationGroupUid: this.platformInfo.locationGroupUid, templateUid: this.templateUid })
          }
          this.$emit('deletePlatform', self.platformInfo.locationGroupUid)
          this.platformData.imageList.splice(0, this.platformData.imageList.length)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.$emit('deleteProjectByLast')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.$emit('deletePlatform', self.platformInfo.locationGroupUid)
        this.platformData.imageList.splice(0, this.platformData.imageList.length)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }
    },
    changeLinkSwitch (e, index) {
      console.log('changeLinkSwitch', e)
      if (!this.platformData.linkList[index]) {
        this.platformData.linkList[index] = {
          index,
          switch: true,
          url: null
        }
      } else {
        this.platformData.linkList[index].switch = e
      }
    },
    handleUploadError (response) {
      this.$notify.error('请上传正确图片')
    },
    handleUploadSuccess3007 (response, fIndex) {
      if (!response) {
        return
      }

      const index = this.selectedLocation.findIndex(item => item.locationUid === '3007')

      const item = this.selectedLocation[index]
      item.mobileOfficialWebsiteVoList[fIndex].imgUrl = `${response}`
      this.selectedLocation.splice(index, 1, item)
    },
    handleUploadSuccess2 (response, file, fileList, type) {
      if (!response) {
        return
      }

      const index = this.selectedLocation.findIndex(item => item.locationUid === '1007')

      const item = this.selectedLocation[index]
      item.generalViewQrCodeUrl = `${response}`
      this.selectedLocation.splice(index, 1, item)
    },

    handleUploadSuccess (response, file, fileList, index, type) {
      if (type) {
        this.imageUrl = `//${response}`
      }

      const i = this.platformData.imageList.findIndex(item => item.index === index)
      if (i === -1) {
        this.platformData.imageList.push({
          index,
          url: `//${response}`
        })
      } else {
        this.platformData.imageList[i].url = `//${response}`
      }
    },
    removeUpload (file, fileList, index) {
      console.log('removeUpload', index)
      console.log('this.platformData', this.platformData)
      const data = this.platformData.imageList
      _.remove(data, item => item.index === index)
      this.platformData.imageList = data
    },
    beforeUpload (file, index) {
      const isLt2M = file.size / 1024 / 1024 < 10

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return isLt2M
    }
  },
  computed: {
    showFn () {
      const that = this
      return function (info) {
        if (info.choosed) {
          return true
        }
        const i = that.selectedLocation.findIndex(e => {
          return e.locationUid === info.id
        })
        if (i === -1) {
          return false
        } else {
          return true
        }
      }
    },
    isLoginOrRegister: function () {
      if (this.previewIndex === '') {
        return 'other'
      }
      // const id = this.platformData.location[this.previewIndex]
      console.log('this.previewIndex', this.previewIndex)
      const info = this.platformInfo.locationDtoList[this.previewIndex]
      console.log('info', info)
      const name = info.locationName.match(/[A-Z][0-9]+/)[0]
      if (!/G/.test(name)) {
        return 'other'
      }
      const num = name.match(/[0-9]{1,2}/)[0]
      if (num >= 8 && num <= 11) {
        return 'login'
      } else if (num >= 12 && num <= 15) {
        return 'register'
      } else {
        return 'other'
      }
    },
    previewImgStyle: function () {
      if (this.previewIndex === '') {
        return ''
      }
      // const id = this.platformData.location[this.previewIndex]
      const info = this.platformInfo.locationDtoList[this.previewIndex]
      const name = info.locationName.match(/[A-Z][0-9]+/)[0]
      const i = previewConfig.findIndex(item => item.name === name)
      if (previewConfig[i] && previewConfig[i].imgStyle) {
        return previewConfig[i].imgStyle
      } else {
        return ''
      }
    },
    getPreviewImg: function () {
      if (this.previewIndex === '') {
        return ''
      }
      return this.platformData.imageList.find(item => item.index === this.previewIndex).url
    },
    previewBackground: function () {
      if (this.previewIndex === '') {
        return ''
      }
      // const id = this.platformData.location[this.previewIndex]
      const info = this.platformInfo.locationDtoList[this.previewIndex]
      const name = info.locationName.match(/[A-Z][0-9]+/)[0]
      const i = previewConfig.findIndex(item => item.name === name)

      if (previewConfig[i] && previewConfig[i].backgroundImageUrl) {
        if (previewConfig[i].panelStyle) {
          return `${previewConfig[i].panelStyle}background: url("${previewConfig[i].backgroundImageUrl}");background-size: 100% 100%;`
        } else {
          return `background: url("${previewConfig[i].backgroundImageUrl}");background-size: 100% 100%;`
        }
      } else {
        return ''
      }
    },
    imgUploadUrl: function () {
      const { apiUrl } = config
      return `${apiUrl}/management/upYun/uploadImg`
    },
    selectedLocation: function () {
      const data = _.intersectionWith(this.platformInfo.locationDtoList, this.platformData.location, (a, b) => {
        if (a.locationUid === b) {
          a.choosed = true
        } else {
          a.choosed = false
        }

        const i = this.platformInfo.locationDtoList.findIndex(e => e.locationUid === b)
        a.index = i
        return a.locationUid === b
      })
      data.forEach(item => {
        if (item.bgFillingShow && item.bgFilling !== 0 && item.bgFilling !== 1) {
          item.bgFilling = 0
        }
        if (item.locationUid === '3007') {
          if (item.mobileOfficialWebsiteDtoList) {
            item.mobileOfficialWebsiteVoList = item.mobileOfficialWebsiteDtoList
          } else {
            item.mobileOfficialWebsiteVoList = [{
              tabName: '',
              imgUrl: '',
              imgSkipUrl: ''
            }, {
              tabName: '',
              imgUrl: '',
              imgSkipUrl: ''
            }]
          }
        }
      })
      console.log('data-ffffffffffff', data)
      return data
    }
  }
}
</script>
<style lang="less">
.item3007 {
  display: flex;

  margin-bottom: 20px;
  flex-direction: column;
  &-add {
    display: flex;
    align-items: center;
    margin-left: 33px;
    span:first-child {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #2878ff;
      cursor: pointer;
    }
    span:last-child {
      font-weight: 400;
      margin-left: 4px;
      font-size: 14px;
      line-height: 18px;
      color: #9ca0a8;
    }
  }
  &-uploader {
    margin-top: 20px;
    display: flex;

    margin-left: 33px;
    & > span {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      width: 80px;
      margin-right: 12px;
      color: #111a2e;
    }
  }
  .label {
    width: 80px !important;
  }
  &-headlineSec {
    margin-left: 33px;
    display: flex;
    align-items: center;
    padding: 9px 16px;
    background: #f8f8f9;
    width: 100%;
    span {
      &:first-child {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #111a2e;
      }
      &:nth-child(2) {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #ff6451;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
.location3007-dialogImg {
  img {
    width: 100%;
    height: 100%;
  }
}
.location3007-dialog .el-dialog__body {
  padding: 0;
}
.location3007 {
  &-swiperWrap {
    height: 360px;
    margin-top: 16px;
    width: 100%;
    overflow: hidden;
  }
  &-swiper {
    display: flex;
    align-items: center;
    & > div {
      width: 288px;
      height: 360px;
      flex-shrink: 0;
      margin-right: 12px;
      img {
        width: 288px;
        height: 360px;
      }
    }
  }
  &-tabs {
    display: flex;
    align-items: center;
    span {
      flex-shrink: 0;
      text-align: center;
      margin-right: 10px;
      background: #ffffff;
      font-weight: 400;
      font-size: 13px;
      color: #4d4d4d;
      box-sizing: border-box;
      border: 0.5px solid #cccccc;
      border-radius: 2px;
      padding: 5px 12px;
    }
  }
  &-tabsactive {
    background: linear-gradient(
        0deg,
        rgba(255, 103, 39, 0.1),
        rgba(255, 103, 39, 0.1)
      ),
      #ffffff !important;
    border: 0.5px solid #ff6727 !important;
    border-radius: 2px;
    color: #ff6727 !important;
    font-weight: 600 !important;
  }
  &-contentHeader {
    display: flex;
    flex-direction: column;
    align-items: center;
    span:first-child {
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      text-align: center;
      letter-spacing: -0.01px;

      color: #333333;
    }
    span:last-child {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-top: 4px;
      color: #666666;
      margin-bottom: 16px;
    }
  }
  &-content {
    padding: 24px 16px;
  }
}
.location3007-dialog {
  .el-dialog__header {
    padding: 0;
  }
}
.location1007-dialogItem_1 {
  color: rgba(245, 125, 20, 1) !important;
}
.location1007-dialogItem_2 {
  color: rgba(0, 136, 221, 1) !important;
  cursor: pointer;
}
.location1007-dialogItem {
  display: flex;
  flex-direction: column;
  & > div {
    position: relative;
    div {
      top: 144px;
      left: 275px;
      font-size: 12px;
      line-height: 18px;
      color: #666666;
      position: absolute;
    }
  }
  & > span {
    font-size: 17.3523px;
    line-height: 22px;
    color: #646a77;
  }
  img {
    width: 100%;
    margin-top: 10px;
  }
}
.location1007-dialogItem2 & > div > div {
  top: 220px;
  left: 224px;
}
.location1007-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 20px;
  }
}
.location1005-dialog {
  .el-dialog__body {
    min-height: 0;
  }
}

.link-1007_span_wrap {
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  box-sizing: border-box;
  img {
    width: 132px;
    margin-top: 10px;
    margin-bottom: 6px;
  }
  span {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    color: #555555;
  }
}
.dashboard-notice__item {
  margin-bottom: 12px;
  width: 926px;
  line-height: 20px;
  padding: 13px 16px;
  position: relative;
  background: #fff6e6;
  border: 1px solid #ffb866;
  border-radius: 2px;
  color: #222;
  text-align: left;
}

.dashboard-notice__item .icon_error {
  width: 16px;
  height: 16px;
  background: url(../../../assets/error_circle.png) no-repeat;
  display: inline-block;
  position: absolute;
  top: 14px;
}
.link-1005_bottom .el-radio:last-child {
  margin-left: 40px;
}
.link-1005_bottom .image-uploader,
.item3007-uploader .image-uploader {
  background: #f8f8f9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.link-1005_bottom img,
.item3007-uploader img,
.link-1005_bottom .el-upload,
.item3007-uploader .el-upload {
  width: 92px;
  height: 92px;
}
.item3007-uploaderDiv {
  & > div {
    display: flex;
  }
  .el-upload-list__item {
    width: 92px;
    height: 92px;
  }
  .el-upload {
    flex-shrink: 0;
  }
}
.link-1005_bottom .el-upload,
.item3007-uploader .el-upload {
  display: flex;
  align-items: center;
  justify-content: center;
}
.link-1007_span {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  position: absolute;
  color: #2878ff;
  left: 260px;
  cursor: pointer;
}
.dashboard-notice__item text {
  font-size: 14px;
  color: #222222;
  display: inline-block;
  vertical-align: top;
  padding-left: 22px;
}

.dashboard-notice__item text .btnShowEditPwd {
  color: #0088dd;
  margin-left: 4px;
  cursor: pointer;
}
.look-location {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  margin-left: 8px;
  color: #6781bd;
}
.dashboard-notice__item .btnClose {
  cursor: pointer;
  position: absolute;
  right: 10px;
  width: 16px;
  height: 16px;
  color: #999;
}
.spread_douyin {
  width: 340px;
  filter: drop-shadow(0px 2px 24px rgba(191, 191, 191, 0.5));
  border-radius: 4px 4px 0px 0px;
  background: #fafafa;
  z-index: 9;
}

.spread_douyin .title {
  width: 100%;
  height: 48px;
  background: #ffffff;
  margin-bottom: 0 !important;
  border-radius: 4px 4px 0px 0px;
}

.spread_douyin .title .icon {
  float: left;
  width: 24px;
  height: 24px;
  margin: 12px;
  margin-right: 0;
  background-image: url("../../../assets/notice.png");
  background-repeat: no-repeat;
}

.spread_douyin .title .hot {
  float: left;
}

.spread_douyin .title .hot:before {
  content: "";
  position: absolute;
  top: 8px;
  left: 35px;
  width: 8px;
  height: 8px;
  line-height: 8px;
  text-align: center;
  background: #ff1133;
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
  font-style: normal;
}

.spread_douyin .title .popupClose {
  float: right;
  margin: 12px;
  width: 24px;
  height: 24px;
  background-image: url("../../../assets/popup_close.png");
  background-repeat: no-repeat;
  cursor: pointer;
}

.spread_douyin.down .title .popupClose {
  background-image: url("../../../assets/popup_up.png");
  background-repeat: no-repeat;
}

.spread_douyin .title .split {
  width: 0px;
  height: 24px;
  border-right: 1px solid #dedede;
  display: inline-block;
  float: left;
  margin: 12px;
}

.spread_douyin .title .tl {
  font-weight: 500;
  font-size: 16px;
  line-height: 48px;
  height: 48px;
  letter-spacing: -0.01px;
  color: #222222;
  flex: 1;
  text-align: center;
}

.spread_douyin .content {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #555555;
  padding: 12px 16px;
}

.spread_douyin .content .opeartion {
  width: 308px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #0088dd;
  border-radius: 2px;
  text-align: center;
  line-height: 40px;
  margin-top: 10px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #0088dd;
  cursor: pointer;
}

.spread_douyin.down {
  width: 218px;
  height: 48px;
}

.spread_douyin.down .title .hot:before {
  display: none;
}

.spread_douyin.down .title .popupClose {
  background-image: url("../../../assets/popup_up.png");
  background-repeat: no-repeat;
}
.el-checkbox__input.is-checked + .el-checkbox__label,
.el-checkbox__label {
  color: #111a2e;
}
.link-1005Button {
  cursor: pointer;
  height: 32px;
  width: 260px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #9ca0a8;
  padding: 0 12px;
  box-sizing: border-box;
  border: 1px solid #e2e3e5;
  background: white;
  border-radius: 0 0 5px 5px;
  &_wrap {
    display: flex;
    width: 260px;
    padding: 0 12px;
    box-sizing: border-box;
    border: 1px solid #e2e3e5;
    background: white;
    border-radius: 0 0 5px 5px;
    > * {
      border: none;
      padding: 0;
      width: 130px;
    }
  }
}
.link-1005,
.link-1006 {
  display: flex;
  align-items: flex-start !important;
  .label {
    min-width: 56px;
  }

  .el-textarea__inner {
    resize: none;
    width: 260px;
    border-radius: 5px 5px 0 0;
  }
}
.link-1005_bottom,
.link-1006_bottom {
  .label {
    min-width: 56px;
  }
  .el-input__inner {
    width: 260px;
  }
}
.link_url {
  .el-input-number__decrease,
  .el-input-number__increase {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.linkInnerShow {
  display: flex;
  align-items: center;
  span:first-child,
  span:nth-child(4) {
    width: 16px;
    height: 16px;
  }
  span:first-child {
    margin-left: 10px;
  }
}
.linkInner {
  display: flex;
  margin-right: 28px;
  align-items: center;
  margin-top: 4px;
  & > span {
    margin: 0 4px;
  }
  .el-input__inner,
  input {
    width: 98px;
  }
  .el-radio {
    margin-right: 10px;
  }
}
.showColorDemo {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: #000;
}
.dialog-footer .el-button {
  display: flex;
}
.choosePosition {
  display: flex;
  font-size: 14px;
  color: #111a2e;
  margin-right: 28px;
  & > span {
    width: 16px;
    height: 16px;
    background: rgb(221, 228, 240);
    text-align: center;
    line-height: 14px;
    margin-right: 4px;
    & > i {
      color: rgb(145, 149, 159);
      font-size: 12px;
    }
  }
}
.panel {
  .el-icon-zoom-in {
    display: none;
  }
  .el-upload-list__item-actions span + span {
    margin-left: 0px;
  }
}
</style>
<style lang="less" scoped>
.preview-disabled {
  color: #9ca0a8 !important;
  cursor: not-allowed;
}
.el-main .panel {
  background-color: var(--white);
  border-radius: 1px;
  padding: 28px;
  margin-top: 12px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    justify-content: space-between;
    span {
      font-size: 20px;
      color: var(--main-text);
    }
    .delete {
      width: 66px;
      height: 28px;
      border-radius: 4px;
      background-color: #f3f3f3;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        font-size: 13px;
        color: #91959f;
        margin-right: 2px;
      }
      font-size: 12px;
      color: #404757;
    }
  }
  .select_location {
    padding-bottom: 17px;
    display: flex;
    align-items: center;
    &__label {
      font-size: 14px;
      margin-right: 12px;
      color: var(--main-text);
    }
  }
  .set_image {
    border-top: 1px dashed var(--form-line);
    padding-top: 24px;
    margin-bottom: 24px;

    .headline {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > span {
        display: inline-block;
        height: 12px;
        width: 1px;
        background: #eeeeee;
        margin: 0 8px;
      }
      & > a {
        font-family: PingFang SC;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        cursor: pointer;
        color: #ff6451;
      }
      .number {
        width: 24px;
        height: 24px;
        border-radius: 50px;
        border: 1px solid var(--form-line);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 11px;
        color: var(--regular-text);
      }
      .location_name {
        margin-left: 9px;
        font-size: 14px;
        margin-right: 12px;
        color: var(--main-text);
      }
      .set_dialog {
        display: flex;
        align-items: center;
        margin-left: 42px;
        &__label {
          color: var(--main-text);
          font-size: 14px;
          margin-right: 12px;
        }
      }
    }
    .upload_image {
      padding-left: 33px;
      .image-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .image-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .default_image {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 144px;
        background-color: #f3f3f3;
        border-radius: 4px;
        height: 144px;
        .image-uploader-icon {
          font-size: 28px;
          margin-top: 58px;
          color: var(--main-text);
          margin-bottom: 16px;
        }
        span {
          color: var(--regular-text);
          font-size: 12px;
        }
      }
      .image {
        width: 144px;
        height: 144px;
        display: block;
        img {
          width: 100%;
        }
      }
    }
    .link {
      padding-left: 33px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      .switch {
        margin-right: 14px;
      }
      .label {
        font-size: 14px;
        margin-top: 3px;
        margin-right: 12px;
        color: var(--main-text);
      }
      .link_url {
        width: 280px;
      }
    }
  }
}
.preview_panel {
  width: 100%;
  height: 600px;
  position: relative;
  img {
    position: absolute;
  }
}
.iframe {
  width: 100%;
  height: 560px;
}
:deep(.el-upload-list__item) {
  transition: none !important;
}
.location1007-dialogItem:first-child {
  & > div > div {
    left: 273px;
    top: 143px;
  }
}
.location10003-dialog img {
  width: 100%;
}
</style>
